import { render, staticRenderFns } from "./BnScrollToAnchor.vue?vue&type=template&id=5835f9f8&scoped=true&"
import script from "./BnScrollToAnchor.vue?vue&type=script&lang=js&"
export * from "./BnScrollToAnchor.vue?vue&type=script&lang=js&"
import style0 from "./BnScrollToAnchor.vue?vue&type=style&index=0&id=5835f9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835f9f8",
  null
  
)

export default component.exports